import actions from './constants';

export const convertDatasetData = (category, code, name) => ({
  category,
  code,
  name,
  type: actions.CONVERT_DATASET_DATA,
});

export const convertDatasetDataSuccess = (category, code, name, result) => ({
  category,
  code,
  datasetName: name,
  result,
  type: actions.CONVERT_DATASET_DATA_SUCCESS,
});

export const convertDatasetDataError = (category, code, name, error) => ({
  category,
  code,
  datasetName: name,
  error,
  type: actions.CONVERT_DATASET_DATA_ERROR,
});

export const convertDictionaryData = (category, code, dictionaryCode, dictionaryName) => ({
  category,
  code,
  dictionaryCode,
  dictionaryName,
  type: actions.CONVERT_DICTIONARY_DATA,
});

export const convertDictionaryDataSuccess = (category, code, dictionaryCode, dictionaryName, result) => ({
  category,
  code,
  dictionaryCode,
  dictionaryName,
  result,
  type: actions.CONVERT_DICTIONARY_DATA_SUCCESS,
});

export const convertDictionaryDataError = (category, code, dictionaryCode, dictionaryName, error) => ({
  category,
  code,
  dictionaryCode,
  dictionaryName,
  error,
  type: actions.CONVERT_DICTIONARY_DATA_ERROR,
});

export const validateDatasetDataSuccess = (category, code, result) => ({
  category,
  code,
  result,
  type: actions.VALIDATE_DATASET_DATA_SUCCESS,
});

export const validateDatasetDataError = (category, code, error) => ({
  category,
  code,
  error,
  type: actions.VALIDATE_DATASET_DATA_ERROR,
});

export const validateDictionaryData = (category, code, dictionaryCode) => ({
  category,
  code,
  dictionaryCode,
  type: actions.VALIDATE_DICTIONARY_DATA,
});

export const validateDictionaryDataSuccess = (category, code, dictionaryCode, result) => ({
  category,
  code,
  dictionaryCode,
  result,
  type: actions.VALIDATE_DICTIONARY_DATA_SUCCESS,
});

export const validateDictionaryDataError = (category, code, dictionaryCode, error) => ({
  category,
  code,
  dictionaryCode,
  error,
  type: actions.VALIDATE_DICTIONARY_DATA_ERROR,
});

export const showValidateDictionaryDataStatus = (category, code, dictionaryCode, dictionaryName, inDialog) => ({
  category,
  code,
  dictionaryCode,
  dictionaryName,
  inDialog,
  type: actions.SHOW_VALIDATE_DICTIONARY_DATA_STATUS,
});

export const hideValidateDictionaryDataStatus = (category, code, dictionaryCode) => ({
  category,
  code,
  dictionaryCode,
  type: actions.HIDE_VALIDATE_DICTIONARY_DATA_STATUS,
});

export const hideValidationServerErrors = (category, code, errors) => ({
  category,
  code,
  errors,
  type: actions.HIDE_VALIDATION_SERVER_ERRORS,
});

export const closeDatasetDataManagement = ({ category, code }) => ({
  category,
  code,
  type: actions.CLOSE_DATASET_DATA_MANAGEMENT,
});
